import { Select, SelectProps, SelectTypeMap } from '@mui/joy'
import { useEditMode } from 'listings/editMode'
import React, { ReactElement, ReactNode } from 'react'

type Props<
    OptionValue extends {},
    Multiple extends boolean,
    D extends React.ElementType = SelectTypeMap<OptionValue, Multiple>['defaultComponent'],
> = SelectProps<OptionValue, Multiple, D> & {
    children?: ReactNode
}

const CustomSelect = <
    OptionValue extends {},
    Multiple extends boolean,
    D extends React.ElementType = SelectTypeMap<OptionValue, Multiple>['defaultComponent'],
>({
    renderNewLines,
    ...props
}: Props<OptionValue, Multiple, D> & { renderNewLines?: boolean }) => {
    const { editMode } = useEditMode()

    if (!editMode) {
        if (props.multiple) {
            const vals = ((props.value as any[]) ?? []).map(value => {
                const option = React.Children.toArray(props.children).find(
                    (child): child is ReactElement =>
                        React.isValidElement(child) && (child.props as any).value === value,
                )
                return (option?.props as any)?.children || value
            })

            if (renderNewLines) {
                return vals.map(x => (
                    <>
                        {x}
                        <br />
                    </>
                ))
            } else {
                return vals.join(', ')
            }
        }
        const option = React.Children.toArray(props.children).find(
            (child): child is ReactElement =>
                React.isValidElement(child) && (child.props as any).value === props.value,
        )
        return (option?.props as any)?.children || props.value
    }

    return <Select {...props} />
}

export default CustomSelect
